<template>
  <div class="plLoading"  @click="close">
    <div class="plLoadingContent">
      <div>
        <div class="plLoadingLogo">
          <!--<img src="/static/imgs/logo.png" width="36" height="36"/>-->
          案件录入中{{points}}
        </div>
        <div class="plLoadingCon">
          <div class="plLoadingShow" ref="plLoadingShow" :style="{'width': plsStyleWidth, 'background-color': '#5cc8f7'}"></div>
          <div class="plLoCir" ref="plLoCir" :style="{'left': plcStyleLeft, 'background-color': '#5cc8f7'}" v-show="plcShow"></div>
          <div class="plLoadingNum" ref="plLoadingNum" :data-percent="percent" ></div>
        </div>
      </div>
    </div>
    <!--测试用的，使用的时候，在父组件创建一个隐藏的Ddiv，里面放入这个页面用到的所有img-->
    <div class="imgsHidden displayNone">
      <img class="hImg" src="http://static.crecgec.com/Kaipiao/countDownTitle.png">
      <img class="hImg" src="http://static.crecgec.com/Kaipiao/countDown.png">
      <img class="hImg" src="http://static.crecgec.com/Kaipiao/countDown1.png">
      <img class="bImg" src="http://static.crecgec.com/Kaipiao/background.png">
      <img class="hImg" src="http://static.crecgec.com/Kaipiao/loadingLogo.png">
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import $ from 'jquery';

export default {
  props: {
    eleH: {
      type: String,
      default: 'hImg'
    },
    eleB: {
      type: String,
      default: 'bImg'
    },
    dataIsOk: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      plsStyleWidth: 0, // plLoadingShow的初始width
      plcStyleLeft: 0, // plLoCir的初始left值
      plcShow: true, // plLoCir初始是显示状态
      backImgLoading: false, // 背景图片是否加载成功(40)
      otherImgLoading: false, // 头部、底部图片加载成功(40)
      dataLoading: '', // 后台返回的数据加载成功(20)
      lodingWidth: 0,
      otherImgLength: 0,
      otherNum: 0,
      backImgLength: 0,
      backNum: 0,
      barBackgroundColor: '#F6AC19',
      points: '......',
      timing: null,
      percent: ''
    };
  },
  watch: {
    // 整个也没被分为三部分：背景图、其他图片、数据
    // 监控otherImgLoading，（其他图片加载成功），this.lodingWidth增加40
    otherImgLoading() {
      this.lodingWidth = this.lodingWidth + 40;
    },
    // 监控otherImgLoading，（背景图片加载成功），this.lodingWidth增加40
    backImgLoading() {
      this.lodingWidth = this.lodingWidth + 45;
    },
    // 监控dataIsOk，（数据加载成功，这个有父组件传递过来），this.lodingWidth增加20
    dataIsOk() {
      if (this.dataIsOk) {
        this.lodingWidth = this.lodingWidth + 20;
      }
    },
    // 监控lodingWidth的值
    lodingWidth() {
      if (this.lodingWidth <= 100) {
        // this.setLoadingWidthTimer(this.lodingWidth);
      }
    },
    // 监控plcStyleLeft（圆球的left值），如果值为484px（自己设置的），表明圆球到了最右边
    // 圆球隐藏
    plcStyleLeft() {
      if (this.plcStyleLeft === '484px') {
        setTimeout(() => {
          this.plcShow = false;
          this.hasScroll();
          this.$emit('tipShow', { loadingIsShow: false });
        }, 500);
      }
    }
  },
  mounted() {
    this.isOtherImgLoading(this.eleH);
    this.isBackImgLoading(this.eleB);
    this.noScroll();
  },
  methods: {
    initPoints() {
      this.timing = setInterval(() => {
        if (this.points === '......') {
          this.points = '.';
        } else {
          this.points = `${this.points}.`;
        }
      }, 500);
    },
    closePoinst() {
      this.points = '......';
      clearInterval(this.timing);
    },
    // 设置width、left
    setLoadingWidthTimer(newPllsWidth) {
      this.barBackgroundColor = this.getColorByBaiFenBi(100 - newPllsWidth);
      if (newPllsWidth <= 50) {
        setTimeout(() => {
          this.plsStyleWidth = `${(500 * newPllsWidth) / 100}px`;
          this.plcStyleLeft = `${(475 * newPllsWidth) / 100}px`;
          // this.$refs.plLoadingNum.innerHTML = `${newPllsWidth}%`;
          this.percent = `${newPllsWidth}%`;
        }, 500);
      } else if (newPllsWidth > 40 && newPllsWidth <= 80) {
        setTimeout(() => {
          this.plsStyleWidth = `${(500 * newPllsWidth) / 100}px`;
          this.plcStyleLeft = `${(484 * newPllsWidth) / 100}px`;
          // this.$refs.plLoadingNum.innerHTML = `${newPllsWidth}%`;
          this.percent = `${newPllsWidth}%`;
        }, 1000);
      } else {
        setTimeout(() => {
          this.plsStyleWidth = `${(500 * newPllsWidth) / 100}px`;
          this.plcStyleLeft = `${(484 * newPllsWidth) / 100}px`;
          // this.$refs.plLoadingNum.innerHTML = `${newPllsWidth}%`;
          this.percent = `${newPllsWidth}%`;
          if (newPllsWidth === 100) {
            this.$emit('loadFinish', 'load finish');
          }
        }, 1500);
      }
    },
    // 弹出层显示的时候，没有滚动条
    noScroll() {
      document.body.style.cssText = 'overflow:hidden;';
    },
    // 弹出层消失后，滚动条显示
    hasScroll() {
      document.body.style.cssText = 'overflow:auto;';
    },
    isOtherImgLoading(ele) {
      this.otherImgLength = $(`.${ele}`).length;
      const this2 = this;
      if (this.otherImgLength > 0) {
        // eslint-disable-next-line
        $(`.${ele}`).each(function () {
          $(this).on('load', () => {
            this2.otherNum += 1;
            if (this2.otherImgLength === this2.otherNum) {
              this2.otherImgLoading = true;
            }
          });
        });
      } else {
        this.otherImgLoading = true;
      }
    },
    isBackImgLoading(ele) {
      this.backImgLength = $(`.${ele}`).length;
      const this2 = this;
      if (this.backImgLength > 0) {
        // eslint-disable-next-line
        $(`.${ele}`).each(function () {
          $(this).on('load', () => {
            this2.backNum += 1;
            if (this2.backImgLength === this2.backNum) {
              this2.backImgLoading = true;
            }
          });
        });
      } else {
        this.backImgLoading = true;
      }
    },
    getColorByBaiFenBi(bili) {
      // var 百分之一 = (单色值范围) / 50;  单颜色的变化范围只在50%之内
      const one = (255 + 255) / 100;
      let r = 0;
      let g = 0;
      let b = 0;

      if (bili < 50) {
        // 比例小于50的时候红色是越来越多的,直到红色为255时(红+绿)变为黄色.
        r = one * bili;
        g = 255;
      }
      if (bili >= 50) {
        // 比例大于50的时候绿色是越来越少的,直到0 变为纯红
        g = 255 - ((bili - 50) * one);
        r = 255;
      }
      r = Math.round(r);// 取整
      g = Math.round(g);// 取整
      b = Math.round(b);// 取整

      // console.log("#"+r.toString(16,2)+g.toString(16,2)+b.toString(16,2));
      // return "#"+r.toString(16,2)+g.toString(16,2)+b.toString(16,2);
      // console.log("rgb("+r+","+g+","+b+")" );
      return `rgb(${r},${g},${b})`;
    },
    close() {
      this.$emit('closeLoading', 'close loading');
    }
  }
};
</script>

<style lang="less" scoped>
  @import "../../../assets/style/variable";
  .plLoading{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, .4);
  }
  .plLoadingContent{
    width: 540px;
    position: absolute;
    margin: 0 auto;
    top: 40%;
    left: 50%;
    margin-top: -110px;
    margin-left: -250px;
    background: #fff;
    padding: 40px;
    &>div {
      padding: 20px;
      border: 1px solid @primary;
    }
  }
  .plLoadingLogo{
    height: 60px;
    padding-top: 30px;
    text-align: center;
    font-size: 2rem;
    font-weight: 600;
    color: #333;
    img {
      margin-right: 1rem;
      vertical-align: middle;
    }
  }
  .plLoadingCon{
    position: relative;
    width: 500px;
    height: 16px;
    margin: 30px 0 30px 0;
    border-radius: 8px;
    background-color: #f7f6f4;
  }
  .plLoadingShow{
    transition: width .5s;
    height: 16px;
    border-radius: 8px;
    /*background-color: #0062b2;*/
    position: absolute;
  }
  .plLoCir{
    transition: left .5s;
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    background-color: #0062b2;
    box-shadow: 0 0 20px #F6AC19;
  }
  .plLoadingNum{
    font-size: 14px;
    color: #0062b2;
    margin-top: 20px;
    margin-left: 102%;
    &:before {
      content: attr(data-percent);
      display: inline-block;
      position: absolute;
      left: 50%;
      top: -24px;
      font-weight: 600;
      font-size: 1rem;
      color: #333;
    }
  }
  .displayNone{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/page/main/import/loading.vue